import { max, min } from 'date-fns';

import { PayloadAction } from '../../../../store.model';
import { groups } from '../const/view-groups.const';
import { filterIsDefault } from '../function/filter-is-default.function';
import { filterItems } from '../function/filter-items.function';
import { groupItems } from '../function/group-items.function';
import { FilterOptions } from '../model/filter-options.model';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';
import { viewTaskItemTransformer } from '../transformer/view-task-item.transformer';

import { ReceiveItems } from './receive-items.action';

export function receiveItemsReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, ReceiveItems>,
): TaskListDialogState {
    try {
        const nextItems = action.payload.tasks ?? [];

        if (action.payload.append === true && state.tasks != null) {
            nextItems.push(...state.tasks);
        }

        nextItems.forEach((task) => {
            task.createdDateTime = new Date(task.createdDateTime);
            task.dueDateTime =
                task.dueDateTime == null ? null : new Date(task.dueDateTime);
        });

        const nextViewItems = viewTaskItemTransformer(nextItems);

        const nextFilt = filterItems({
            items: nextViewItems,
            filterOpts: state.filterOpts,
            orderBy: state.orderBy,
        });

        const nextFiltOpts: FilterOptions = {
            ...state.filterOpts,
            minDate: min(nextItems.map((e) => e.dueDateTime) ?? []),
            maxDate: max(nextItems.map((e) => e.dueDateTime) ?? []),
        };

        const nextFiltDef = filterIsDefault(state.filterOpts);

        const nextGroups = groupItems(groups, nextFilt);

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            filterOpts: nextFiltOpts,
            filterIsDefault: nextFiltDef,
            tasks: nextItems,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return {
            ...state,
        };
    }
}
